//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-param-reassign */
import { ref, computed, onMounted } from '@vue/composition-api'
import { mdiPlus, mdiDeleteOutline, mdiClose, mdiMenuDown } from '@mdi/js'
import { required, emailValidator } from '@core/utils/validation'
import { useUtils } from '@core/libs/i18n'
import usePhone from '@core/utils/usePhone'
import parsePhoneNumber from 'libphonenumber-js'
import useCountry from '@core/utils/useCountry'

export default {
  name: 'AddGuest',
  model: {
    prop: 'isModalOpen',
    event: 'update:is-modal-open',
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    requiredPhone: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const { phoneCodeOptions } = usePhone()
    const { getCountryCode } = useCountry()

    const form = ref(null)
    const dataGuest = ref({
      guest_phone_number: null,
      guest_name: null,
    })
    const computedRequiredPhone = computed(() => props.requiredPhone)

    const isPhoneVisible = ref(false)
    const initCode = ref(null)
    const code = ref(null)
    const phoneCode = ref(null)
    const fullPhone = ref(null)

    const onClearCode = () => {
      phoneCode.value = initCode.value
      fullPhone.value = null
      isPhoneVisible.value = false
    }

    const validatePhone = e => {
      if (!/^([0-9])*$/.test(e)) {
        isPhoneVisible.value = false

        return 'Invalid number'
      }

      if (phoneCode.value && e) {
        const phoneNumberJS = parsePhoneNumber(e, phoneCode.value)
        if (phoneNumberJS) {
          if (phoneNumberJS.isValid()) {
            fullPhone.value = phoneNumberJS.number

            return true
          }
          fullPhone.value = null
        }
      } else if (!code.value.includes('+')) {
        onClearCode()
      }

      return 'Invalid number'
    }

    const onInputCode = e => {
      if (!isPhoneVisible.value && e && e !== '' && e.length) {
        if (e.length > 1) {
          if (/^\+?([0-9])+$/.test(e)) {
            code.value = code.value.replace('+', '')
            phoneCode.value = initCode.value
            isPhoneVisible.value = true
          }
        }
      }
    }

    const onSave = () => {
      if (form.value.validate()) {
        dataGuest.value.guest_phone_number = isPhoneVisible.value ? fullPhone.value : code.value
        emit('add-guest', dataGuest.value)
        dataGuest.value = {
          guest_phone_number: null,
          guest_name: null,
        }
        form.value.resetValidation()
      }
    }

    onMounted(() => {
      const countryCode = getCountryCode()
      if (countryCode) {
        const codeFinded = phoneCodeOptions.value.find(e => e.value === countryCode)
        if (codeFinded) initCode.value = countryCode
        else initCode.value = 'US'
      }
    })

    return {
      // data
      form,
      dataGuest,

      isPhoneVisible,
      initCode,
      code,
      phoneCode,
      fullPhone,
      phoneCodeOptions,

      // computed
      computedRequiredPhone,

      // methods
      onSave,
      onInputCode,
      onClearCode,

      // validations
      validators: {
        required,
        emailValidator,
        validatePhone,
      },

      // i18n
      t,

      // icons
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiClose,
        mdiMenuDown,
      },
    }
  },
}
